export const FLIPDISH_MESSAGES_VALUE = '4';

// Values are sent to the API as numeric strings. The API accepts values beyond its
// documented enum (5 and 6), so keep this list in sync with the mobile app.
export const CONTACT_FORM_TYPE_OPTIONS: ReadonlyArray<{ value: string; label: TranslationId }> = [
  { value: '0', label: 'None' },
  { value: '1', label: 'Email' },
  { value: '5', label: 'Contact_form_type_phone' },
  { value: '6', label: 'Contact_form_type_email_and_phone' },
  { value: '3', label: 'Contact_form_type_web_view' },
  { value: '2', label: 'Contact_form_type_intercom' },
  { value: FLIPDISH_MESSAGES_VALUE, label: 'Contact_form_type_flipdish_messages' },
];

const VALUE_BY_NAME: Record<string, string> = {
  none: '0',
  email: '1',
  intercom: '2',
  webview: '3',
  flipdishmessages: '4',
  phone: '5',
  emailandphone: '6',
};

/**
 * The API may return either the enum name ("WebView") or a numeric string ("3").
 * Both map to the same option value; anything unrecognised returns undefined.
 */
export const normalizeContactFormType = (raw?: string | number | null): string | undefined => {
  if (raw === undefined || raw === null) {
    return undefined;
  }
  const text = String(raw).trim();
  if (/^\d+$/.test(text)) {
    return CONTACT_FORM_TYPE_OPTIONS.some((option) => option.value === text) ? text : undefined;
  }
  return VALUE_BY_NAME[text.toLowerCase().replace(/[\s_-]/g, '')];
};
